import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  return <section id="pricing" className="pt-10 pb-8 md:pt-24 md:pb-16 px-4 relative" data-id="element-80">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#0ea5e9]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-81" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-83">
          <p className="text-xl text-gray-400 mb-6" data-id="element-84">
            No vas a pagar{' '}
            <span className="line-through decoration-red-500/50" data-id="element-85">$282</span>. Ni
            siquiera los $70 que cuesta una suscripción anual de una app
            genérica.
          </p>

          <h2 className="text-2xl md:text-3xl font-medium mb-12" data-id="element-86">
            Queremos que esta sea la decisión más sencilla de tu carrera
            profesional.
          </h2>

          <div className="mb-4" data-id="element-87">
            <p className="text-sm font-bold tracking-widest text-[#00d4ff] uppercase mb-2" data-id="element-88">
              Llévatelo todo hoy por un solo pago de:
            </p>
            <div className="text-7xl md:text-9xl font-bold text-white tracking-tighter drop-shadow-[0_0_30px_rgba(14,165,233,0.3)]" data-id="element-89">
              $27
            </div>
          </div>

          <p className="text-gray-500 italic mb-12" data-id="element-90">
            (Menos de lo que cuesta una cena afuera, para recuperar tu paz
            mental de por vida).
          </p>

          <motion.a href="https://www.rutinasimple.com/cart/52072631009561:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto group relative inline-flex items-center justify-center px-8 md:px-12 py-5 md:py-6 text-lg md:text-xl font-bold text-white bg-gradient-to-r from-[#0ea5e9] to-[#0284c7] rounded-2xl overflow-hidden transition-all shadow-[0_0_40px_rgba(14,165,233,0.3)] hover:shadow-[0_0_60px_rgba(14,165,233,0.5)]" data-id="element-91">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-92" />
            <span className="relative flex items-center gap-3" data-id="element-93">
              <LockIcon className="w-5 h-5" data-id="element-94" />
              SÍ, QUIERO EL PROTOCOLO DE PAUSA
              <span className="hidden md:inline" data-id="element-95">
                — ACCESO INMEDIATO POR $27
              </span>
            </span>
          </motion.a>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-96">
            <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-97" />
            <span data-id="element-98">Pago 100% seguro. Acceso instantáneo al material.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}